// src/components/layout/Header.js
import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { useAuth } from "../utils/AuthContext";
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { FaBars, FaThLarge } from 'react-icons/fa';

const CATEGORY_TABS = [
  { label: "HOME", to: "/" },
  { label: "MYME 게임", to: "/games" },
  { label: "MYME 소식", to: "/events" },
  { label: "MYME 게임잼", to: "/gamejam" },
];

export default function Header() {
  const { user, isAdmin } = useAuth();

  const handleLogout = async () => {
    await signOut(auth);
    window.location.href = '/';
  };

  return (
    <header className="bg-neutral-800 text-white">
      {/* ── 상단 AuthBar ── */}
      <div className="container mx-auto flex justify-between items-center h-20 px-4 pt-4 text-sm text-gray-300">
        {/* 로고 이미지 */}
        <Link to="/" className="flex items-center">
          <img src="/images/logo/logo_main1.png" alt="MYME 게임즈 로고" className="h-10 w-auto mr-4" />
          <p className="text-xl font-bold">
            <span className="text-red-500">MYME</span>{' '}
            <span className="text-white">게임</span>
          </p>
        </Link>

        <div className="flex items-center space-x-6">
          {!user ? (
            <>
              <Link to="/login" className="hover:text-white">로그인</Link>
              <Link to="/signup" className="hover:text-white">회원가입</Link>
            </>
          ) : (
            <>
              {isAdmin && (
                <Link
                  to="/admin"
                  className="hover:text-red-500 flex items-center text-sm"
                >
                  <FaThLarge className="mr-2" size={14} /> 관리페이지
                </Link>
              )}
              <button onClick={handleLogout} className="hover:text-red-500">
                로그아웃
              </button>
            </>
          )}
        </div>
      </div>

      {/* ── 하단 CategoryBar ── */}
      <nav className="bg-neutral-800">
        <div className="container mx-auto flex items-center h-12 px-4">
          <button className="md:hidden p-2 hover:bg-gray-700 rounded">
            <FaBars size={16} />
          </button>
          <div className="flex items-center space-x-8 text-base font-bold ml-4 mt-4">
            {CATEGORY_TABS.map((tab, idx) => {
              const isLast = idx === CATEGORY_TABS.length - 1;

              if (isLast) {
                // 마지막 탭: active 시 밑줄만 주고, 텍스트 색상은 고정
                return (
                  <NavLink
                    key={tab.to}
                    to={tab.to}
                    className={({ isActive }) => {
                      const base = 'relative pb-2 text-yellow-400';
                      const underline = isActive
                        ? 'after:absolute after:-bottom-0 after:left-0 after:right-0 after:h-1 after:bg-yellow-400'
                        : '';
                      return `${base} ${underline}`;
                    }}
                  >
                    {tab.label}
                  </NavLink>
                );
              }

              // 나머지 탭: 기존 동작 유지
              return (
                <NavLink
                  key={tab.to}
                  to={tab.to}
                  className={({ isActive }) => {
                    const base = 'relative pb-2';
                    const active = 'text-red-500 after:absolute after:-bottom-0 after:left-0 after:right-0 after:h-1 after:bg-red-500';
                    const inactive = 'text-gray-300 hover:text-gray-100';
                    return `${base} ${isActive ? active : inactive}`;
                  }}
                >
                  {tab.label}
                </NavLink>
              );
            })}
          </div>
        </div>
      </nav>
    </header>
  );
}
